import { useTranslation } from 'react-i18next';
import { Download, Share, SquarePlus } from 'lucide-react';
import { Button } from '@easymoving/ui';
import { useInstallPrompt } from '../../pwa/useInstallPrompt';
import { isIosSafari } from '../../pwa/platform';

/**
 * "Install the app" card. Chromium fires beforeinstallprompt → native button;
 * iOS never does → manual Share → Add-to-Home-Screen instructions instead.
 */
export function InstallCard() {
  const { t } = useTranslation();
  const { canInstall, installed, promptInstall } = useInstallPrompt();

  if (!canInstall && !installed && isIosSafari()) {
    return (
      <div className="surface p-4 flex items-start gap-3" data-testid="ios-install-hint">
        <span className="size-10 shrink-0 rounded-xl bg-petrol-tint text-petrol flex items-center justify-center">
          <Download className="size-5" />
        </span>
        <div className="min-w-0">
          <div className="font-medium text-[15px] leading-tight">{t('more.installTitle')}</div>
          <ol className="text-graphite text-[13px] mt-1.5 flex flex-col gap-1">
            <li className="flex items-center gap-1.5">
              <span className="tnum">1.</span>
              <Share className="size-3.5 text-petrol shrink-0" />
              {t('more.iosStep1')}
            </li>
            <li className="flex items-center gap-1.5">
              <span className="tnum">2.</span>
              <SquarePlus className="size-3.5 text-petrol shrink-0" />
              {t('more.iosStep2')}
            </li>
          </ol>
        </div>
      </div>
    );
  }

  if (!canInstall) return null;

  return (
    <div className="surface p-4 flex items-center gap-3">
      <span className="size-10 shrink-0 rounded-xl bg-petrol-tint text-petrol flex items-center justify-center">
        <Download className="size-5" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="font-medium text-[15px] leading-tight">{t('more.installTitle')}</div>
        <div className="text-graphite-soft text-[13px]">{t('more.installBody')}</div>
      </div>
      <Button size="sm" onClick={() => void promptInstall()} className="shrink-0">
        {t('more.installCta')}
      </Button>
    </div>
  );
}
